import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { useAuth } from '../../hooks/useAuth';
import { PDFDownloadLink } from '@react-pdf/renderer';
import SingleCommuter from '../PdfFiles/SingleCommuterPDF';

const CommuterDetails = (props) => {
    const [userId, setUserId] = useState('');
    const [data, setData] = useState();
    const [allUnits, setAllUnits] = useState('');
    const location = useLocation();
    const { getToken } = useAuth();
    useEffect(() => {
        const { state } = location;
        getCommuterDetail(state?.user_id);
        getMeasuredUnits();
    }, []);

    const getCommuterDetail = async (id) => {
        const token = getToken();
        if (token && id) {
            new WebApiCalls()
                .getSingleCommuter(token, id)
                .then((res) => {
                    setData(res);
                })
                .catch((err) => {});
        }
    };

    const getMeasuredUnits = async () => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getRewardSettings(token)
                .then((res) => {
                    if (res?.code == 200) {
                        setAllUnits(res?.data);
                    }
                })
                .catch((err) => {});
        }
    };

    return (
        <>
            <Row className="justify-content-end align-items-center">
                <Col sm={4} md={4} className="d-flex justify-content-end align-items-center gap-2">
                    {data ? (
                        <PDFDownloadLink document={<SingleCommuter commuter_data={data} />} fileName="commuter.pdf">
                            {({ loading }) =>
                                loading ? (
                                    <Spinner animation="border" variant="success" />
                                ) : (
                                    <Button className="export-file justify-content-center w-140 align-items-center" style={{ background: '#198754', padding: '9px' }}>
                                        Export PDF
                                    </Button>
                                )
                            }
                        </PDFDownloadLink>
                    ) : (
                        <Spinner animation="border" variant="success" />
                    )}
                    <Link to="/commuters">
                        <Button className="theme-cancel-btn px-5 py-2">Close</Button>
                    </Link>
                </Col>
            </Row>

            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="p-4 m-3">
                    <Row>
                        <Col sm={6} md={3} className="mb-4">
                            <div className="detail-small-heading">Name</div>
                            <div className="detail-value">{data?.name || 'N/A'}</div>
                        </Col>

                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-headingg">Email</div>
                            <div className="detail-value lower-case">{data?.email || 'N/A'}</div>
                        </Col>

                        <Col sm={6} md={3} className="mb-4">
                            <div className="detail-small-heading">Phone Number</div>
                            <div className="detail-value">{data?.phone_no || 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Gender</div>
                            <div className="detail-value">{data?.gender || 'N/A'}</div>
                        </Col>

                        <Col sm={6} md={3} className="mb-4">
                            <div className="detail-small-heading">DOB</div>
                            <div className="detail-value">{data?.dob ? moment(data?.dob).format('MM-DD-YYYY') : 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-heading">City</div>
                            <div className="detail-value">{data?.city || 'N/A'}</div>
                        </Col>
                        <Col sm={6} md={3} className="mb-4">
                            <div className="detail-small-heading">Province/Territory</div>
                            <div className="detail-value">{data?.region || 'N/A'}</div>
                        </Col>

                        <Col sm={6} md={2} className="mb-4">
                            <div className="detail-small-heading">Number of Trips</div>
                            <div className="detail-value">{data?.noOfTrips}</div>
                        </Col>

                        <Col sm={6} md={3} className="mb-4">
                            <div className="detail-small-heading">Distance Travelled</div>
                            <div className="detail-value">
                                {data?.totalDistance || 0}
                                {data?.totalDistance ? `${allUnits?.distanceUnit}` : ''}
                            </div>
                        </Col>

                        <Col sm={6} md={4} className="mb-4">
                            <div className="detail-small-heading">GHG Emissions Saved</div>
                            <div className="detail-value">
                                {data?.GHGsaved || 0}
                                {data?.GHGsaved ? `${allUnits?.ghgUnit}` : ''}
                            </div>
                        </Col>

                        <Col sm={6} md={3} className="mb-4">
                            <div className="detail-small-heading">Earned Points</div>
                            <div className="detail-value">{data?.reward_points || 0}</div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
};

export default CommuterDetails;
